<template>
  <div id="create_level_modal" class="modal fade rtl" role="dialog">
    <div class="modal-dialog">

      <!-- Modal content-->
      <div class="modal-content">
        <div class="modal-header mx-auto">
          <h5>فرم ایجاد سطح</h5>
        </div>
        <div class="modal-body mb-4 mx-4">
          <form id="create_level_form" class="kt-form" @submit.prevent="createLevel">
            <kt-form-section>
              <kt-form-row>
                <kt-col xs="12" sm="12" md="12">
                  <kt-form-group>
                    <kt-form-label for="level_name">
                      {{ $t('label.level_name') }}
                    </kt-form-label>
                    <kt-form-control
                        type="text"
                        ref="level_name"
                        placeholder="سطح 1"
                        dir="rtl"
                        name="level_name"
                        id="level_name"
                        v-model="level_name"
                    />
                  </kt-form-group>
                </kt-col>
                <kt-col xs="12" sm="12" md="12">
                  <kt-form-group>
                    <kt-form-label for="settlement_limit">
                      {{ $t('label.settlement_limit') }}
                    </kt-form-label>
                    <kt-form-control
                        type="number"
                        placeholder="ریال"
                        ref="settlement_limit"
                        dir="rtl"
                        name="settlement_limit"
                        id="settlement_limit"
                        v-model="settlement_limit"
                    />
                    <span v-if="formatLess(settlement_limit) >= 10">
                        <span v-text="Num2persian(Math.floor(formatLess(settlement_limit) / 10))"></span>&nbsp;
                        <span v-text="$t('label.toman')"></span>
                    </span>
                  </kt-form-group>
                </kt-col>
                <kt-col class="my-3" xs="12" sm="6" md="6">
                  <div class="custom-switch custom-control">
                    <input
                        type="checkbox"
                        class="custom-control-input"
                        id="iban_national_id_matching"
                        name="iban_national_id_matching"
                        v-model="iban_national_id_matching"
                    >
                    <label class="custom-control-label" for="iban_national_id_matching">{{ $t('label.iban_national_id_matching') }}</label>
                  </div>
                </kt-col>
                <kt-col class="my-3" xs="12" sm="6" md="6">
                  <div class="custom-switch custom-control">
                    <input
                        type="checkbox"
                        class="custom-control-input"
                        id="phone_national_id_matching"
                        name="phone_national_id_matching"
                        v-model="phone_national_id_matching"
                    >
                    <label class="custom-control-label" for="phone_national_id_matching">{{ $t('label.phone_national_id_matching') }}</label>
                  </div>
                </kt-col>
                <kt-col class="mt-3" xs="12" sm="6" md="6">
                  <div class="custom-switch custom-control">
                    <input
                        type="checkbox"
                        class="custom-control-input"
                        id="otp_authentication_condition"
                        name="otp_authentication_condition"
                        v-model="otp_authentication_condition"
                    >
                    <label class="custom-control-label" for="otp_authentication_condition">{{ $t('label.otp_authentication_condition') }}</label>
                  </div>
                </kt-col>
                <kt-col xs="12" sm="12" md="12" class="mt-2">
                    <div class="kt-login__actions mt-5">
                        <kt-button type="submit" id="create_level_btn" variant="brand" class="btn btn-success">
                            {{ $t('label.create') }}
                        </kt-button>
                    </div>
                </kt-col>
              </kt-form-row>
            </kt-form-section>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import $ from "jquery"
import {KTApp} from "@/plugins/core/app";
import {walletService} from "@/common/api.service";
import toastr from "toastr";
import Num2persian from 'num2persian';

export default {
  name: "CreateLevelModal",
  data() {
    return {
      level_name: null,
      settlement_limit: "",
      iban_national_id_matching: false,
      phone_national_id_matching: false,
      otp_authentication_condition: false,
      Num2persian
    }
  },
  computed: {
    toastr() {
      toastr.options = {
        closeButton: true,
        positionClass: "toast-bottom-center",
        preventDuplicates: false,
        rtl: false
      }

      return toastr
    }
  },
  methods: {
    createLevel() {
      let form = $('#create_level_form')
      let btn = $('#create_level_btn')

      form.validate({
        rules: {
          level_name: {
            required: true
          },
          settlement_limit: {
            required:true
          },
        }
      })

      if (!form.valid()) {
        return
      }
      KTApp.progress(btn)

      let params = {
        name: this.level_name,
        settlement_limit: this.settlement_limit,
        iban_national_id_matching: this.iban_national_id_matching,
        phone_national_id_matching: this.phone_national_id_matching,
        otp_authentication_condition: this.otp_authentication_condition,
      }

      walletService.createLevelForShareholder(params)
          .then(response => {
            this.toastr.success(response.data.message)
            $("#create_level_modal").modal("hide")
            $('#create_level_modal').on('hidden.bs.modal', function () {
              $('#create_level_form')[0].reset();
            });
            this.$emit('refreshDatatable')
          })
          .catch(({response}) => {
            this.toastr.error(response.data.message)
          })
          .finally(() => {
            KTApp.unprogress(btn)
          })
    }
  }
}
</script>

<style scoped>

</style>